module.exports = __webpack_public_path__ + "static/img/sexual_violence.7c426f7a.png";